var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 3840 2460",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3840,
    height: 2460,
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "35.9%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "35.9%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#ceffb2",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "35.9%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#ceffb2",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "64.1%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "64.1%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#ceffb2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#8fff5e",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "64.1%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18.780487804878046%",
    stopColor: "#ceffb2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81.21951219512195%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3840, 2460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1938.2 0C-1867 -180.3 -1795.7 -360.5 -1755.7 -570.4C-1715.6 -780.4 -1706.6 -1020 -1568 -1139.2C-1429.4 -1258.5 -1161.2 -1257.5 -984 -1354.3C-806.7 -1451.1 -720.5 -1645.8 -571.7 -1759.5C-422.9 -1873.1 -211.4 -1905.6 0 -1938.2L0 0Z",
    fill: "#e8ffd8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1292.1 0C-1244.6 -120.2 -1197.2 -240.3 -1170.4 -380.3C-1143.7 -520.2 -1137.7 -680 -1045.3 -759.5C-952.9 -839 -774.1 -838.3 -656 -902.9C-537.8 -967.4 -480.3 -1097.2 -381.1 -1173C-281.9 -1248.7 -141 -1270.4 0 -1292.1L0 0Z",
    fill: "#b1ff8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-646.1 0C-622.3 -60.1 -598.6 -120.2 -585.2 -190.1C-571.9 -260.1 -568.9 -340 -522.7 -379.7C-476.5 -419.5 -387.1 -419.2 -328 -451.4C-268.9 -483.7 -240.2 -548.6 -190.6 -586.5C-141 -624.4 -70.5 -635.2 0 -646.1L0 0Z",
    fill: "#8fff5e"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1938.2 0C1857.4 196.3 1776.7 392.5 1664.3 540.8C1552 689.1 1408.2 789.4 1333.3 968.7C1258.3 1148 1252.4 1406.3 1139.2 1568C1026.1 1729.7 805.7 1794.7 597.9 1840.3C390.2 1885.9 195.1 1912 0 1938.2L0 0Z",
    fill: "#e8ffd8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.1 0C1238.3 130.8 1184.4 261.7 1109.6 360.5C1034.7 459.4 938.8 526.2 888.8 645.8C838.9 765.3 834.9 937.6 759.5 1045.3C684 1153.1 537.1 1196.5 398.6 1226.9C260.1 1257.3 130.1 1274.7 0 1292.1L0 0Z",
    fill: "#b1ff8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.1 0C619.1 65.4 592.2 130.8 554.8 180.3C517.3 229.7 469.4 263.1 444.4 322.9C419.4 382.7 417.5 468.8 379.7 522.7C342 576.6 268.6 598.2 199.3 613.4C130.1 628.6 65 637.3 0 646.1L0 0Z",
    fill: "#8fff5e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.f72e29643e548bb963ba162f2a98bc6b.svg";
export { ForwardRef as ReactComponent };